var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0883 7.53548C9.41772 7.53548 8.75925 7.43059 8.13527 7.22438C7.82951 7.1201 7.45364 7.21577 7.26703 7.40743L6.0354 8.33717C4.60707 7.57473 3.72725 6.69519 2.97522 5.27758L3.87761 4.07805C4.11205 3.84392 4.19614 3.5019 4.09539 3.181C3.8883 2.55373 3.7831 1.89558 3.7831 1.22467C3.78313 0.740004 3.38883 0.345703 2.90419 0.345703H0.892611C0.407972 0.345703 0.0136719 0.740004 0.0136719 1.22464C0.0136719 6.77988 4.53311 11.2993 10.0883 11.2993C10.573 11.2993 10.9673 10.905 10.9673 10.4203V8.41439C10.9673 7.92978 10.573 7.53548 10.0883 7.53548Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephone-icon.28d95e502a0821468040070bcf7352af.svg";
export { ForwardRef as ReactComponent };